module.exports = __webpack_public_path__ + "static/media/latex-allergy-09.549d6238.svg";